
<ng-container>
  <sss-layout>
    <div class="px-4" >
      <router-outlet></router-outlet>
    </div>
  </sss-layout>
</ng-container>
